export default function TrustBadgesStrip() {
  const badges = [
    { icon: 'ri-shield-check-fill', label: 'C-10 Licensed', value: 'CA License' },
    { icon: 'ri-star-fill', label: '4.9 Star Rating', value: '500+ Reviews' },
    { icon: 'ri-time-fill', label: '24/7 Emergency', value: 'Always Available' },
    { icon: 'ri-award-fill', label: '15+ Years', value: 'Experience' },
  ];

  return (
    <section className="py-8 sm:py-12 bg-[#1a1a1a] border-y-4 border-[#FFD700]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {badges.map((badge, index) => (
            <div key={index} className="flex flex-col items-center text-center gap-3">
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#FFD700] rounded-full">
                <i className={`${badge.icon} text-[#1a1a1a] text-2xl sm:text-3xl`}></i>
              </div>
              <div>
                <div className="text-white font-black text-base sm:text-lg">{badge.label}</div>
                <div className="text-[#FFD700] text-xs sm:text-sm font-medium">{badge.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}